<template>
  <div>
    <CrudList
      title="Faqs"
      storeName="Faqs"
      :canAdd="user.user_role != 'admin_enterprise'"
      :canEdit="true"
      :canDelete="true"
      :role_admin_enterprise="user.user_role == 'admin_enterprise'"
      sortable
    >
      <template v-slot:type="{ item }">
        <p v-for="type of item.type">
          {{type}}
        </p>
      </template>
    </CrudList>
  </div>
</template>

<script>
  import CrudList from "@/components/Crud/CrudList";
import { mapState } from 'vuex';

  export default {
    components: {CrudList},
    computed: {
      ...mapState({
        user: state => state.Authenticate.user,
      }),
    },
    data(){
      return{
        role_enterprise: false, 
      }
    },
    async created() {
      const self = this;
      await self.$store.dispatch("Authenticate/me");
    }
  };
</script>
